import Backend from 'i18next-http-backend';

// english
import toast from './assets/i18n/en/toast.json';
import errors from './assets/i18n/en/errors.json';
import LanguageDetector from 'i18next-browser-languagedetector';

import ICU from 'i18next-icu';
import i18next from 'i18next';

export const localeKey = 'locale';
export const defaultNS = 'shared';

export type ErrorCode = keyof typeof errors;
export type ToastKey = keyof typeof toast;
export const namespaces = ['shared', 'account', 'auth', 'errors', 'toast', 'faq'];

declare module 'i18next' {
    interface CustomTypeOptions {
        defaultNS: typeof defaultNS;
        returnNull: false;
    }
}

i18next
    .use(Backend)
    .use(ICU)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        backend: {
            loadPath: 'assets/i18n/{{lng}}/{{ns}}.json'
        },
        ns: namespaces, // not sure if we need 'errors' and 'toast' here?
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        },
        defaultNS,
        debug: true,
        keySeparator: false, // we do not use keys in form messages.welcome
        detection: {
            lookupLocalStorage: localeKey,
            lookupSessionStorage: localeKey
        }
    });

export const updateLocale = (locale: string) => {
    i18next
        .changeLanguage(locale)
        .then()
        .catch(error => console.warn('error on changing locale::', error));
};

export { i18next };
